module.exports = __webpack_public_path__ + "assets/img/twjd.86f005da.png";